import Select from "@aleaplay/web-components/ui/Select";

import { FormChild } from "@/v1/components/atoms/FormChild";
import { useTranslation } from "@/v2/hooks/useTranslation";
import { TypeNewsletter } from "@/v2/utils/constants";
import { getGenericRequiredErrorV2 } from "@/v2/utils/getGenericRequiredError";

export const NewsletterTypeSelect = () => {
  const { t } = useTranslation();
  return (
    <FormChild>
      <Select
        id="type"
        name="type"
        type="autocomplete"
        placeholder={t("placeholder.test-newsletter")}
        label={t("label.newsletter")}
        errors={getGenericRequiredErrorV2(t)}
      >
        <Select.Option key={TypeNewsletter.DAILY} value={TypeNewsletter.DAILY}>
          {t("label.daily")}
        </Select.Option>
        <Select.Option key={TypeNewsletter.WEEKLY} value={TypeNewsletter.WEEKLY}>
          {t("label.weekly")}
        </Select.Option>
      </Select>
    </FormChild>
  );
};
